<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Schedule</span>
      <span v-else>Edit Schedule </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col md="6" class="mx-auto">
            <v-row>
              <v-col class="py-2" cols="12">
                <form-group name="name" :attribute="`fields.name`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.name"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-2" cols="12">
                <form-group name="time" :attribute="`fields.time`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.time"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" class="py-2">
                <section class="increment-label">
                  <span>Order</span>
                  <number-input
                    center
                    v-model="form.order"
                    :min="1"
                    :step="1"
                    controls
                  ></number-input>
                </section>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="success mt-5 text-capitalize"
                  large
                  type="submit"
                  width="100%"
                  :disabled="$v.form.$invalid"
                  ><span>Save</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      busLocations: [],
      form: {
        name: "",
        order: "",
        time: ""
      },
      maxSize: 2.048,
      resetLogo: false,
      Logo: false,
      Photo: false,
      stopTime: false,
      returnTime: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      countries: []
    };
  },
  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createLocation();
      } else {
        this.editBusStop();
      }
    },
    editCreateBoolean() {
      if (this.$route.name != "CampsSubTypesSchedulesDetailsCreate") {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules/${this.$route.params.index}/details`,
        id: id
      })
        .then(res => {
          const { detail } = res.data;
          this.form = detail;
        })
        .catch(() => {});
    },
    createLocation() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules/${this.$route.params.index}/details`,
        data: formData
      })
        .then(() => {
          history.go(-1);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editBusStop() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (this.form[formItem] != null) {
          formData.append(formItem, this.form[formItem]);
        }
      });

      formData.append("_method", "put");
      UpdateData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules/${this.$route.params.index}/details`,
        data: formData,
        id: this.$route.params.detail
      })
        .then(() => {
          this.isEdited = false;
          history.go(-1);

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "CampsSubTypesSchedulesDetailsEdit") {
          this.$nextTick(() => {
            this.showData(route.params.detail);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(190)
      },
      time: {
        required
      }
    }
  }
};
</script>
